import md5 from 'js-md5';

/* eslint-disable array-element-newline */
const DEFAULT_PARTIAL_RENDER_FORMAT = 'raw';

/**
 * @typedef {Object} PartialRenderOutputJsonItem
 * @prop {string} param_hash
 * @prop {string} content
 */

/**
 * @template {string} T
 * @typedef {Object} PartialRenderOutputJson
 * @prop {1|0} success
 * @prop {Record<T, PartialRenderOutputJsonItem>} data
 */

export class PartialRenderController {

	/**
	 * @param {import('lit').LitElement} host
	 */
	constructor (host) {
		// Add controller to host
		(this.host = host)?.addController(this);
	}

	/**
	 * @param {string} format
	 */
	#validateOutputFormat (format) {
		if (typeof format !== 'string') {
			return DEFAULT_PARTIAL_RENDER_FORMAT;
		}

		switch (format.toLowerCase()) {
			default:
			case 'raw':
				return 'raw';
			case 'json':
				return 'json';
		}
	}

	/**
	 * Encodes parameters with md5 if they exist
	 * @param {string} item
	 */
	encodeItem (item) {
		const [itemString, param] = item.split(':');

		return param
			? `${itemString}:${md5(param)}`
			: itemString;
	}

	/**
	 * @overload
	 * @param {string} url
	 * @param {string[]} items
	 * @param {'raw'} outputFormat
	 * @returns {Promise<string>}
	 */
	/**
	 * @template {string} T
	 * @overload
	 * @param {string} url
	 * @param {T[]} items
	 * @param {'json'} outputFormat
	 * @returns {Promise<PartialRenderOutputJson<T>>}
	 */
	async send (url, items, outputFormat = DEFAULT_PARTIAL_RENDER_FORMAT) {
		const validatedFormat = this.#validateOutputFormat(outputFormat);

		const response = await fetch(url, {
			headers: [
				['X-Miva-Partial-Render', items.map(item => this.encodeItem(item)).join(',')],
				['X-Miva-Partial-Render-Output', validatedFormat]
			]
		});

		const output = validatedFormat === 'json'
			? await response.json()
			: await response.text();

		return output;
	}
};
